import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { SolicitudDocumentosRequestDto } from '../../../dto/expediente/documentos.dto';
import { DocumentosService } from '../../../services/documentos.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { ModalService } from '../../../services/util/modal.service';
import { ListasService } from '../../../services/listas.service';
import { AsuntoSolicitudDocumentoDto } from '../../../dto/expediente/asunto-solicitud-documento.dto';
import { UserDataDto } from '../../../dto/auth/user-data.dto';

@Component({
  selector: 'app-solicitud-documentos',
  templateUrl: './solicitud-documentos.component.html',
  styleUrl: './solicitud-documentos.component.scss',
})
export class SolicitudDocumentosComponent implements OnInit {
  data: any;
  asuntosList: AsuntoSolicitudDocumentoDto[] = [];
  solicitudForm: FormGroup = this.fb.group({});
  userData: UserDataDto = {};

  constructor(
    @Inject('modalData') private injectedData: any,
    private fb: FormBuilder,
    private documentosService: DocumentosService,
    private alertModalService: AlertaModalService,
    private modalService: ModalService,
    private listService: ListasService
  ) {
    this.data = injectedData;
  }

  ngOnInit(): void {
    this.userData = JSON.parse(
      sessionStorage.getItem('user_information_session')!
    );
    this.listService.getAsuntoSolicitudDocumentosList().subscribe(resp => {
      this.asuntosList = resp;
    });
    this._initForm();
  }

  onSubmit(): void {
    const destinatariosControl = this.solicitudForm.get('otrosDestinatarios');
    const destinatarios: string[] = destinatariosControl?.value
      ? destinatariosControl.value
          .split(/[\s,;]+/)
          .map((email: string) => email.trim())
      : [];
    if (this.solicitudForm.valid) {
      const solicitudDocumentosRequest: SolicitudDocumentosRequestDto = {
        remitente: this.solicitudForm.get('remitente')?.value,
        correoRespuesta: this.solicitudForm.get('correoRespuesta')?.value,
        otrosDestinatarios: destinatarios,
        asunto: this.solicitudForm.get('asunto')?.value,
        numeroProceso: this.solicitudForm
          .get('numeroProceso')
          ?.value.toString(),
        descripcion: this.solicitudForm.get('descripcion')?.value,
        idUsuario: parseInt('' + this.userData.idUsuario),
        idEntidad: parseInt(this.data.entidadId),
      };

      this.documentosService
        .crearSolicitudDocumentos(solicitudDocumentosRequest)
        .subscribe(resp => {
          resp.success
            ? this.alertModalService.exito(
                'Solicitud enviada',
                'Recuerde que una vez realizada una solicitud deberá esperar 24 horas antes de realizar una nueva solicitud a la entidad'
              )
            : this.alertModalService.error(
                'No pudimos completar tu solicitud',
                `${resp.message}`
              );
          this.modalService.close();
        });
    }
  }

  private _emailsValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    const emails: string[] = control.value
      .split(/[\s,;]+/)
      .map((email: string) => email.trim());
    const invalidEmails: string[] = emails.filter(
      (email: string) => !this.isValidEmail(email)
    );
    return invalidEmails.length
      ? { invalidEmails: invalidEmails.join(', ') }
      : null;
  }

  private isValidEmail(email: string): boolean {
    const emailPattern: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  private _initForm(): void {
    this.solicitudForm = this.fb.group({
      remitente: [
        { value: this.userData.correoElectronico || '', disabled: true },
        Validators.required,
      ],
      correoRespuesta: [
        { value: this.userData.correoElectronico || '', disabled: true },
        Validators.required,
      ],
      otrosDestinatarios: ['', [this._emailsValidator.bind(this)]],
      asunto: ['', [Validators.required]],
      numeroProceso: [
        { value: this.data.numeroProceso || '', disabled: true },
        Validators.required,
      ],
      descripcion: ['', [Validators.required, Validators.maxLength(600)]],
    });
  }

  protected readonly undefined = undefined;
}
